// extracted by mini-css-extract-plugin
export default {"tabs":"z1-z","tablist":"A1-z","tablistItem":"B1-z"};